export enum TipoVersiones{
    Todas = 1,
    Reales = 2,
    Parciales = 3,
}